/** Locale-aware date and date-range formatting. */
const LOCALE_MAP = { de: "de-DE", en: "en-US" };

function loc(lang) {
  return LOCALE_MAP[lang?.startsWith("en") ? "en" : "de"];
}

export function formatDate(iso, lang, opts = { year: "numeric", month: "short", day: "2-digit" }) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(loc(lang), opts).format(d);
}

export function formatDateRange(fromIso, untilIso, lang) {
  if (!fromIso && !untilIso) return "";
  const from = formatDate(fromIso, lang, { day: "2-digit", month: "short" });
  const until = formatDate(untilIso, lang, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  if (!fromIso) return until;
  if (!untilIso) return from;
  return `${from} – ${until}`;
}

export function formatDateTime(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(loc(lang), {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

export function shortId(id) {
  if (!id) return "";
  return String(id).slice(0, 8).toUpperCase();
}
